module.exports = __webpack_public_path__ + "img/profile-white.d79cf2b0.svg";